import { homeConstant } from "../_constants/homeConstant";
import { homeService } from "../_services/homeServices";
import { alert } from "../_utilities/alert";
import { configes } from "../webData";

export const homeAction = {
  getFaq,
  contact,
  carRegister,
  getBrandsByTenantId
};

function getFaq() {
  // console.log(60, getFaq);
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: homeConstant.GET_fAQ_REQUEST,
        data: null,
      })
    );
    homeService
      .getFaq()
      .then(
        (response) => {
          if (response.Status === 200) {
            dispatch(
              dispatchFunction({
                type: homeConstant.GET_fAQ_SUCCESS,
                data: response.Result.faqs,
              })
            );
            // alert.success(response.Message);
          } else {
            dispatch(
              dispatchFunction({
                type: homeConstant.GET_fAQ_FAILURE,
                data: null,
              })
            );
            // alert.error(response.Message);
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: homeConstant.GET_fAQ_FAILURE,
              data: error,
            })
          );
          alert.error("Oops! Something went wrong!!");
        }
      )
      .catch(() => {
        alert.error("Oops! Something went wrong!!");
      });
  };
}

function contact(data) {
  console.log(104, data);
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: homeConstant.CONTACT_REQUEST,
        data: null,
      })
    );
    homeService
      .contact({ ...data, tenantId: configes.domainId })
      .then(
        (responce) => {
          if (responce.Status === 200) {
            dispatch(
              dispatchFunction({
                type: homeConstant.CONTACT_SUCCESS,
                data: responce.Result.multyWebsiteContact,
              })
            );
            alert.success(responce.Message);
          } else {
            dispatch(
              dispatchFunction({
                type: homeConstant.CONTACT_FAILURE,
                data: responce.Message,
              })
            );
            alert.error(responce.Message);
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: homeConstant.CONTACT_FAILURE,
              data: error,
            })
          );
          alert.error("Oops! Something went wrong!!");
        }
      )
      .catch(() => {
        alert.error("Oops! Something went wrong!!");
      });
  };
}

function carRegister(data) {
  console.log(151, data);
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: homeConstant.CAR_REGISTER_FORM_REQUEST,
        data: null,
      })
    );
    homeService
      .carRegister({ ...data, tenantId: configes.domainId })
      .then(
        (response) => {
          if (response.Status === 200) {
            dispatch(
              dispatchFunction({
                type: homeConstant.CAR_REGISTER_FORM_SUCCESS,
                data: response.Result.CarRegister,
              })
            );
          } else {
            dispatch(
              dispatchFunction({
                type: homeConstant.CAR_REGISTER_FORM_FAILURE,
                data: null,
              })
            );
            alert.error("Oops! Something went wrong!!");
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: homeConstant.CAR_REGISTER_FORM_FAILURE,
              data: error,
            })
          );
        }
      )
      .catch(() => {
        alert.error("Oops! Something went wrong!!");
      });
  };
}

function getBrandsByTenantId() {
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: homeConstant.GET_ALLBRANDS_REQUEST,
        data: null,
      })
    );
    homeService
      .getBrandsByTenantId()
      .then(
        (response) => {
          if (response.Status === 200) {
            dispatch(
              dispatchFunction({
                type: homeConstant.GET_ALLBRANDS_SUCCESS,
                data: response.Result.brands,
              })
            );
          } else {
            dispatch(
              dispatchFunction({
                type: homeConstant.GET_ALLBRANDS_FAILURE,
                data: null,
              })
            );
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: homeConstant.GET_ALLBRANDS_FAILURE,
              data: error,
            })
          );
        }
      )
      .catch(() => {
        alert.error("Oops! Something went wrong!!");
      });
  };
}

function dispatchFunction(data) {
  return {
    type: data.type,
    data: data.data,
  };
}
